import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { getUserMedia } from '../services/mediaService';
import styles from '../styles/components/ImageSelector.module.scss';

const ImageSelector = ({ isOpen, onClose, onSelect, currentValue }) => {
    const { currentUser } = useAuth();
    const [mediaList, setMediaList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedImage, setSelectedImage] = useState(currentValue || '');

    useEffect(() => {
        if (isOpen && currentUser) {
            loadMedia();
        }
    }, [isOpen, currentUser]);

    const loadMedia = async () => {
        try {
            setIsLoading(true);
            const media = await getUserMedia(currentUser.uid);
            setMediaList(media);
        } catch (error) {
            console.error('メディア読み込みエラー:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSelect = () => {
        onSelect(selectedImage);
        onClose();
    };

    const handleCancel = () => {
        setSelectedImage(currentValue || '');
        onClose();
    };

    const filteredMedia = mediaList.filter(media =>
        media.originalName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={handleCancel}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h3>画像を選択</h3>
                    <button onClick={handleCancel} className={styles.closeButton}>
                        ×
                    </button>
                </div>

                <div className={styles.searchSection}>
                    <input
                        type="text"
                        placeholder="画像名で検索..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>

                <div className={styles.content}>
                    {isLoading ? (
                        <div className={styles.loading}>読み込み中...</div>
                    ) : filteredMedia.length === 0 ? (
                        <div className={styles.emptyState}>
                            {searchTerm ? '検索結果がありません' : '画像がアップロードされていません'}
                        </div>
                    ) : (
                        <div className={styles.imageGrid}>
                            {filteredMedia.map((media) => (
                                <div
                                    key={media.id}
                                    className={`${styles.imageItem} ${selectedImage === media.downloadURL ? styles.selected : ''
                                        }`}
                                    onClick={() => setSelectedImage(media.downloadURL)}
                                >
                                    <div className={styles.imageContainer}>
                                        <img
                                            src={media.downloadURL}
                                            alt={media.originalName}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                                e.target.nextSibling.style.display = 'flex';
                                            }}
                                        />
                                        <div className={styles.imageError} style={{ display: 'none' }}>
                                            読み込みエラー
                                        </div>
                                    </div>
                                    <div className={styles.imageInfo}>
                                        <div className={styles.imageName}>{media.originalName}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className={styles.footer}>
                    <button onClick={handleCancel} className={styles.cancelButton}>
                        キャンセル
                    </button>
                    <button
                        onClick={handleSelect}
                        className={styles.selectButton}
                        disabled={!selectedImage}
                    >
                        選択
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImageSelector; 